<ng-container *ngIf="!readonlyInternal">
  <fieldset class="multi-checkbox-input">
    <legend [ngClass]="{'legend-invalid': formControl?.touched && formControl?.invalid}">
      {{ fgInfo?.label || labelOverride }}{{ formControl['condrequired'] || fgInfo?.required ? '*' : '' }}
      <mat-icon
        [hidden]="!tooltipText"
        [matTooltip]="tooltipText"
        [matTooltipPosition]="'after'"
        [attr.aria-label]="'Tooltip: ' + tooltipText"
        tabindex="0"
      >
        help
      </mat-icon>
    </legend>
    <div class="no-options-placeholder" *ngIf="flatOptions?.length === 0">
      No options to select
    </div>
    <ul *ngIf="flatOptions?.length > 0">
      <li *ngFor="let option of flatOptions; index as i">
        <mat-checkbox
          [required]="fgInfo.required"
          [disabled]="option.isDisabled"
          (change)="handleChange($event, option)"
          [ngClass]="{ 'allow-pointer': tooltipText }"
          class="app-checkbox"
          [checked]="controlHasValue(option)"
        >
          <span
            [class]="hideLabel ? 'visually-hidden' : ''"
            [attr.aria-label]="(fgInfo?.label || labelOverride) + ' input : ' + option?.name || ''"
          >
            {{ option?.name }}
          </span>
        </mat-checkbox>
      </li>
    </ul>
    <div class="checkbox-error mat-hint" *ngIf="hint && (!formControl.touched || formControl.valid)">
      {{ hint }}
    </div>
    <div class="checkbox-error mat-error" *ngFor="let errorDefinition of errorDefinitions">
      <ng-container *ngIf="formControl.touched && errorDefinition.showFunction()">
        {{ errorDefinition.errorMessage(formControl) }}
      </ng-container>
    </div>
  </fieldset>
</ng-container>
<ng-container *ngIf="readonlyInternal">
  <mat-form-field
    class="no-underline w-100"
    [attr.data-automation-id]="dataAutomationId"
    floatLabel="always"
    [ngClass]="{
      'read-only': readonlyInternal,
      'allow-pointer': tooltipText,
      'no-label': hideLabel
    }"
  >
    <mat-label>
      {{ labelOverride || fgInfo.label }}
      <mat-icon
        [hidden]="!tooltipText"
        [matTooltip]="tooltipText"
        [matTooltipPosition]="'after'"
        [attr.aria-label]="'Tooltip: ' + tooltipText"
      >
        help
      </mat-icon>
    </mat-label>
    <textarea
      readonly
      matInput
      cdkTextareaAutosize
      [attr.data-automation-id]="dataAutomationId"
      #autosize="cdkTextareaAutosize"
      cdkAutosizeMinRows="1"
      [value]="showTrimmedText ? trimmedText : (overrideReadonlyValue || currentSelection || '')"
      tabindex="-1"
    ></textarea>
  </mat-form-field>
  <p *ngIf="showTrimmedText && noteIsLong">
    <span class="show-more" (click)="showTrimmedText = false">See more</span>
  </p>
  <p *ngIf="!showTrimmedText">
    <span class="show-more" (click)="showTrimmedText = true">See less</span>
  </p>
</ng-container>
